var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Header"},[_c('div',{class:[
            'Header__bar',
            _vm.showBottomBar && 'Header__bar--top'
        ]},[_vm._t("header",[_c('h3',{class:_vm.statusBuilder('Header__header', _vm.status)},[_vm._v(" "+_vm._s(_vm.header)+" ")])]),_vm._t("actions")],2),(_vm.showBottomBar)?_c('div',{staticClass:"Header__bar"},[_vm._t("info"),_vm._t("filters")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }